<div class="searchable-dropdown">
  <label *ngIf="label">{{ label }}</label>
  <div class="dropdown-container" #dropdownReference>
    <div class="input-wrapper" (click)="toggleDropdown()">
      <div class="selected-items" *ngIf="showSelectedInInput && selectedItems.length > 0 && !isSearchMode">
        <div class="selected-item">
          <span class="item-name">{{ getItemDisplayText(selectedItems[0]) }}{{ selectedItems.length > 1 ? ', +' + (selectedItems.length - 1) : '' }}</span>
          <span class="remove-item" *ngIf="multiSelect" (click)="toggleItemSelection(selectedItems[0]); $event.stopPropagation()">
          </span>
        </div>
      </div>
      
      <input 
        #searchInput
        type="text" 
        class="search-input"
        [formControl]="searchControl"
        [placeholder]="placeholder || ('common.inputs.select.placeholder' | translate)"
        (click)="showDropdown(); $event.stopPropagation()"
        (input)="onSearchChange(searchControl.value)"
        (focus)="onInputFocus()"
        (blur)="onInputBlur()"
        [class.hidden-input]="showSelectedInInput && (!isSearchMode && selectedItems.length !== 0)"
      >
      <div class="dropdown-icon">
        <mat-icon>{{ isDropdownVisible ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
      </div>
    </div>

    <ng-template cdkPortal>
      <div class="dropdown-panel">
        <div class="loading-indicator" *ngIf="loading">
          <mat-spinner diameter="24"></mat-spinner>
        </div>

        <div class="items-list" *ngIf="!loading">

          <div class="item" 
            *ngFor="let item of filteredItems" 
            [class.selected]="isItemSelected(item)"
            (click)="toggleItemSelection(item); $event.stopPropagation()"
          >
            <div class="selection-indicator" *ngIf="multiSelect">
              <div class="checkbox" [class.checkbox-selected]="isItemSelected(item)"></div>
            </div>
            <div class="item-details">
              <div class="item-name" [innerHTML]="getHighlightedText(item)"></div>
            </div>
          </div>

          <div class="no-results" *ngIf="filteredItems.length === 0 && !searchControl.value">
            {{ 'common.inputs.select.no_results' | translate }}
          </div>
          
          <div class="create-button" *ngIf="showAddOption" (click)="onAddNewClick()">
            <ng-container *ngIf="!searchControl.value">
              {{ 'request_v2.category_form.create_new' | translate }}
            </ng-container>
            <ng-container *ngIf="searchControl.value">
              {{ 'request_v2.category_form.create_with_name' | translate: { name: searchControl.value } }}
            </ng-container>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div> 